import { Box } from "@mui/material/";
import SvgIcon from "@mui/material/SvgIcon";
import { Link } from "react-router-dom";
const Bulletin = (props: any) => {
    const renderIcon = (iconPath: string) => (
        <SvgIcon viewBox="0 0 24 24" className="svg">
            <path d={iconPath} />
        </SvgIcon>
    );
    return (
        <div className="bulletin-container">
            {props.bulletinData?.bulletin &&
                props.bulletinData.bulletin.length > 0 &&
                props.bulletinData.bulletin.map((bulletin: any, index: number) => (

                    <Box
                        key={index}
                        style={{
                            backgroundColor: bulletin.colour_code,
                        }}
                        className="bulletin"
                    >

                        {bulletin.icon && renderIcon(bulletin.icon)}
                        <span>{bulletin.content_desc}</span>
                            {bulletin.redirect_link === "-" ? (
                                ""
                            ) : (
                                <b>
                                    <Link to={bulletin.redirect_link} target="_blank" className="bulletinLink">
                                        {" "}
                                        Click Here{" "}
                                    </Link>
                                </b>
                            )}
                    </Box>
                ))}
        </div>
    );
};

export default Bulletin;
